import React, { useEffect, useState } from "react";
import { BASE_URL } from "../env";
import * as ReactBootStrap from "react-bootstrap";

function Table() {
	const [Questions, setQuestion] = useState([]);
	useEffect(() => {
		fetch(BASE_URL + "/GetAllQuestionAdmin")
			.then((response) => response.json())
			.then((data) => {
				console.log("courses", data);
				setQuestion(data?.questions);
			});
	}, []);
	return (
		<div>
			<table data-toggle="table" class="table table-hover">
				<thead class="thead-dark">
					<tr>
						<th class="text-dark ">Questions</th>
					</tr>
				</thead>
				<tbody>
					{Questions.map((val) => {
						return <option value={val?._id}>{val?.name}</option>;
					})}
				</tbody>
			</table>
		</div>
	);
}
export default Table;
